import debug, { IDebugger } from 'debug';

const BASE = 'gruhn-modern-web';

const COLORS: any = {
    error: 'red',
    info: 'blue',
    trace: 'lightblue',
    warn: 'orange'
};

// we know this color property exists but it was not included in @types for some reason...
interface DebuggerColored extends IDebugger {
    color: string;
}

class Log {
    public error(message: any, source?: string): void {
        return this.generateMessage('error', message, source);
    }

    public info(message: any, source?: string): void {
        return this.generateMessage('info', message, source);
    }

    public trace(message: any, source?: string): void {
        return this.generateMessage('trace', message, source);
    }

    public warn(message: any, source?: string): void {
        return this.generateMessage('warn', message, source);
    }

    private generateMessage(level: string, message: any, source?: string): void {
        const nameSpace = `${BASE}:${level}`;
        const createDebug = debug(nameSpace) as DebuggerColored;

        createDebug.color = COLORS[level];

        if (source) { createDebug(source, message); } else { createDebug(message); }
    }
}

export default new Log();



// WEBPACK FOOTER //
// ./src/providers/log.ts